import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentRiskAreaDto extends EpimsBaseEntityDto {
  
  IncidentEventTypeId: string;
  EventName: string;
  RiskAreaName: string;
  RiskAreaDescription: string;
  SubscriptionUserId: string;  
  Version: number;
}
